import { languagesList } from "@/i18n";
import { LanguageCodeEnum } from "@/i18n";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class LangControls extends Vue {
  langOptions = languagesList.map((locale) => ({
    value: locale.code,
    label: locale.name,
  }));

  onLangChange(val: string) {
    this.$i18n.locale = val;
  }

  get currentLang(): LanguageCodeEnum {
    return this.$i18n.locale as LanguageCodeEnum;
  }
}
